import type { CategoryListItemDto } from '@/queries/categories/categories.schema';
import { useTranslations } from 'next-intl';
import { Icon } from '@/components/entities/Sprite/Icon';
import CategoryItem from '@/components/features/layout/Navigation/components/Sidebar/components/SidebarContent/components/NavigationItems/components/CategoryItem';
import { CustomAccordion } from '@/components/ui/Accordion/CustomAccordion';

interface OtherCategoriesAccordionProps {
  handleCloseSideBar: () => void;
  isMenuMinify: boolean;
  categoryId: string;
  otherCategories: CategoryListItemDto[];
}

const OtherCategoriesAccordion = ({
  handleCloseSideBar,
  isMenuMinify,
  categoryId,
  otherCategories,
}: OtherCategoriesAccordionProps) => {
  const t = useTranslations('side-menu');

  return (
    <div>
      <CustomAccordion
        itemClassName="rounded-[1.5rem] md:rounded-[1.375rem] 3xl:rounded-[1.5rem] data-[state=open]:bg-main-800/60"
        triggerClassName='group relative bg-transparent py-2.5 px-3 md:px-3 items-center justify-start justify-between rounded-[3.125rem] min-w-0
                transition-transform duration-150 ease-in-out md:data-[state=closed]:hover:scale-[1.02]
                before:content-[""] before:absolute before:inset-0 before:rounded-[3.125rem]
                before:bg-main-800 before:opacity-0 before:transition-opacity before:duration-200 before:pointer-events-none
                hover:before:opacity-100'
        contentClassName="bg-transparent p-0 mt-1"
        iconClosed={<Icon name="arrow-top" className="relative size-4 shrink-0 text-violet-c200 rotate-180 transition-transform duration-500" />}
        iconOpened={<Icon name="arrow-top" className="relative size-4 shrink-0 text-violet-c200 rotate-0 transition-transform duration-500" />}
        items={[
          {
            value: 'other-categories',
            trigger: (
              <div className="flex items-center gap-2 text-c100 paragraph-s-medium">
                <Icon name="other-category" className="relative size-6 shrink-0 text-c100 group-hover:text-white " />
                <span className="relative paragraph-s-medium group-hover:text-white ">{t('more-categories')}</span>
              </div>
            ),
            content: (
              <div className="flex flex-col gap-1 px-1 pb-1">
                {otherCategories.map(category => (
                  <CategoryItem
                    key={category.id}
                    category={category}
                    categoryId={categoryId}
                    handleCloseSideBar={handleCloseSideBar}
                    isMenuMinify={isMenuMinify}
                  />
                ))}
              </div>
            ),
          },
        ]}
        collapsible
      />
    </div>
  );
};

export default OtherCategoriesAccordion;
